import React from 'react'
import Topbar from './Topbar';
import PermissionTable from './PermissionTable';

export default function Index() {
  return (
    <div style={{margin:'auto',width:'95%', marginTop:'2%'}}>
        <PermissionTable/>
    </div>
  )
}
